export default __webpack_public_path__ + "address-contact.svg";